module.exports = __webpack_public_path__ + "img/computer_4.66c0cfe2.png";